import React from 'react';
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';

// Components
import SEOHead from './components/SEOHead';
import StickyCallBar from './components/StickyCallBar';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import WhyChooseSection from './components/WhyChooseSection';
import ReviewsSection from './components/ReviewsSection';
import ServiceAreaSection from './components/ServiceAreaSection';
import HoursLocationSection from './components/HoursLocationSection';
import FinalCTASection from './components/FinalCTASection';
import Footer from './components/Footer';

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-slate-50">
      <SEOHead />
      <Header />
      <main>
        <HeroSection />
        <ServicesSection />
        <WhyChooseSection />
        <ReviewsSection />
        <ServiceAreaSection />
        <HoursLocationSection />
        <FinalCTASection />
      </main>
      <Footer />
      <StickyCallBar />
    </div>
  );
};

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="*" element={<LandingPage />} />
          </Routes>
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
